import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import { ReleaseListHeaderCell, TableRow, TableSeparator } from 'components';
import { Creators as TableCreators } from 'reducers/Table';

import t2Styles from './Table2.module.scss';

const mapStateToProps = ({ releases, playQueue, global, table }) => ({
	sortedField: releases.sort,
	playingItem: playQueue.selectedItem,
	isIpadView: global.isIpadView,
	tableWidths: table
});


@connect(mapStateToProps)
class Table2 extends React.PureComponent {
	static propTypes = {
		items: PropTypes.arrayOf(PropTypes.object),
		columns: PropTypes.arrayOf(PropTypes.object),
		renderModal: PropTypes.func,
		onPlay: PropTypes.func,
		onClick: PropTypes.func,
		t: PropTypes.func,
		playingItem: PropTypes.object,
		isIpadView: PropTypes.bool,
		onHoverStop: PropTypes.func,
		controlledHover: PropTypes.bool,
		tableWidths: PropTypes.object,
		dispatch: PropTypes.func.isRequired,
		tableId: PropTypes.string.isRequired
	}
	static defaultProps = {
		controlledHover: false,
	};

	state = {
		sortedField: null,
		selectedItem: null
	}

	componentDidMount() {
		this.isMovingBarrier = false;
		this.movingBarrierField = -1;
		this.lastPosition = 0;
		this.setState({
			sortedItems: null,
			sortedField: null,
			sortedOrder: 'asc'
		});
	}

	componentDidUpdate(prevProps) {
		const { items: newItems } = this.props;
		const { items: prevItems } = prevProps;

		if (newItems !== prevItems) {
			/* eslint-disable react/no-did-update-set-state */
			// Refresh the sorted item list
			const { sortedField, sortedOrder } = this.state;

			if (!sortedField) {
				// Setting state improperly to skip an unneeded render
				this.state.sortedItems = newItems;
			} else {
				const sortedItems = [...newItems].sort(
					this.compareValues(sortedField, sortedOrder)
				);
				this.setState({ sortedItems });
			}
			/* eslint-enable react/no-did-update-set-state */
		}
	}

	componentWillUnmount() {
	}

	handleSortBy = newSort => {
		const { sortedField, sortedOrder } = this.state;
		const { items } = this.props;
		let newSortedOrder = 'asc';
		if (sortedField === newSort) {
			if (sortedOrder === 'asc') {
				newSortedOrder = 'desc';
			} else {
				newSortedOrder = 'asc';
			}
		}
		const sortedItems = [...items].sort(
			this.compareValues(newSort, newSortedOrder)
		);
		this.setState({
			sortedField: newSort,
			sortedItems,
			sortedOrder: newSortedOrder
		});
	}

	handleClickOnField = field => {
		if (field) {
			// const { isMovingBarrier } = this;
			// if (!isMovingBarrier) {
				this.handleSortBy(field);
			// }
		}
	}

	setSelectedItem = (item) => this.setState({ selectedItem: item });

	compareValues = (key, order = 'asc') => {
		return (a, b) => {
			if (
				!Object.prototype.hasOwnProperty.call(a, key) ||
				!Object.prototype.hasOwnProperty.call(b, key)
			) {
				return 0;
			}
			const varA =
				typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
			const varB =
				typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];
			let comparison = 0;
			if (varA > varB) {
				comparison = 1;
			} else if (varA < varB) {
				comparison = -1;
			}
			return order === 'desc' ? comparison * -1 : comparison;
		};
	}

	renderBody = () => {
		const {
			items,
			columns,
			isIpadView,
			playingItem,
			controlledHover,
			t,
			renderModal,
			onPlay,
			onClick,
			onHoverStop,
			tableWidths,
			tableId
		} = this.props;
		const { sortedField, sortedItems, selectedItem } = this.state;

		const bodyCells = (sortedField ? sortedItems : items).map(item => {
			let isHighlighted = false;
			if (item && playingItem) {
				if (item.trackid) {
					if (item.trackid === playingItem.trackid) {
						isHighlighted = true;
					}
				} else if (item.releaseid === playingItem.releaseid) {
					isHighlighted = true;
				}
			}
			return (
				<div key={item.id} className={`min-w-full w-max-content ${t2Styles['table-row-container']}`}>
					<TableRow
						isIpadView={isIpadView}
						isHighlighted={isHighlighted}
						controlledHover={controlledHover}
						columns={columns}
            item={item}
            tableId={tableId}
						resizableWidths={tableWidths[tableId]}
						renderModal={renderModal}
						selectedItem={selectedItem}
						setSelectedItem={this.setSelectedItem}
						onPlay={onPlay}
						onClick={onClick}
						onHoverStop={onHoverStop} />
				</div>
			);
		});
		if (items.length === 0) {
			return (
				<div className="flex flex-col items-center mt-40 text-white font-header mx-auto">
					{t('release-list.noresults')}
					<Link push="true" to="/releases">
						<div className="text-white font-header bg-lightNavy px-12 py-2 mt-4 rounded-full shadow-button">
							{t('search.view-releases')}
						</div>
					</Link>
				</div>
			);
		} else {
			return bodyCells;
		}
	}

	renderHeader = () => {
		const { columns, renderModal, tableWidths, tableId } = this.props;
		const { sortedField, sortedOrder } = this.state;
		const releaseHeaderCells = columns.map((item, index) => {
			// const resizableWidth = tableWidths[tableId][item.field];
			const width = item.width;
			// if (item.image) {
			// 	return '';
			// } else {
				return (
					<div
						key={`${item.title} ${index + 1}`}
						className={`flex flex-row items-center ${
							item.cellClassName
            } ${item.desktopOnly ? 'xl:flex hidden' : ''} ${item.cellStyleName ? t2Styles[item.cellStyleName] || '' : ''}`}
            style={{ width, useDrag: 'none' }}
						onClick={() => {
							this.handleClickOnField(item.sort);
						}}>
						<ReleaseListHeaderCell
							name={item.title}
							clickable={item.sort}
							sortedField={sortedOrder === 'asc' && sortedField} />
						{index !== columns.length - 1 ? (
							<React.Fragment>
								{/* <TableSeparator
									handleMouseDown={
										item.resizable &&
										(event => {
											event.stopPropagation();
											this.handleMouseDownSeparator(
												event,
												item.field,
												width
											);
										})
									} /> */}
							</React.Fragment>
						) : (
							null
						)}
					</div>
				);
			// }
		});
		return (
			<div className="relative w-full my-4">
				<div
					className={`flex flex-row items-center justify-start w-full ${t2Styles['header-container']}`}>
					{/* <div className="relative w-10 h-10 mx-2 flex-none" /> */}
					{releaseHeaderCells}
					{renderModal && <div className="w-12" />}
				</div>
			</div>
		);
	}


	render() {
    const { tableId } = this.props;
		return (
				<div className={`overflow-x-auto ${tableId ? t2Styles[tableId] || '' : ''}`}>
					{ this.renderHeader() }
					{ this.renderBody() }
				</div>
		);
	}
}

export default withTranslation()(Table2);
